import { Component, OnInit, signal } from '@angular/core';
import { TRANSLOCO_SCOPE, TranslocoModule } from '@jsverse/transloco';
import {
  QaiAccordionItemDirective,
  QaiAccordionHeaderDirective,
  QaiAccordionToggleDirective,
  QaiAccordionBodyDirective,
  QaiIconComponent,
} from '@qai/ui';

const STORAGE_KEY = 'kc-tips-panel-expanded';

// Collapsible "Tips for writing answer points" panel (SR-21516).
// Expanded by default; collapsed state is persisted in localStorage.
@Component({
  selector: 'knowledge-check-tips-panel',
  standalone: true,
  templateUrl: './knowledge-check-tips-panel.component.html',
  styleUrls: ['./knowledge-check-tips-panel.component.scss'],
  imports: [
    QaiAccordionItemDirective,
    QaiAccordionHeaderDirective,
    QaiAccordionToggleDirective,
    QaiAccordionBodyDirective,
    QaiIconComponent,
    TranslocoModule,
  ],
  providers: [{ provide: TRANSLOCO_SCOPE, useValue: 'simulationBuilder' }],
})
export class KnowledgeCheckTipsPanelComponent implements OnInit {
  readonly expanded = signal(true);

  ngOnInit(): void {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored !== null) {
      this.expanded.set(stored === 'true');
    }
  }

  onExpandedChange(value: boolean): void {
    this.expanded.set(value);
    localStorage.setItem(STORAGE_KEY, String(value));
  }
}
